export default __webpack_public_path__ + "locales/uk-UA/SingleSignOn.json?hash=6f545c3c0bd139be0c64283da654a2ac";